<template>
  <InputNumber
    v-model="percentVal"
    :formatter="value => `${value}%`"
    :parser="value => value.replace('%', '')">
  </InputNumber>
</template>

<script>
import XEUtils from 'xe-utils'
export default {
  name: 'PercentInputNumber',
  props: ['value'],
  computed: {
    percentVal: {
      get: function () {
        return this.value ? XEUtils.multiply(this.value, 100) : 0
      },
      set: function (value) {
        this.$emit('input', XEUtils.divide(value, 100))
      }
    }
  }
}
</script>
